<template>
  <div>
    <section class="xlrclh">
      <img class="top-img" src="./../assets/imgs/144/base.png" alt="" />
      <div class="technological-process">
        <div class="rhtj mar-t2">
          <img class="top" src="./../assets/imgs/125/desc-title.png" alt="" />
          <div class="content">
            为深入贯彻落实《蒲江县加快建设具有比较优势的人才聚集地若干政策措施》（蒲委室〔2023〕4号）第七条、第十一条文件要求，制定本实施细则。
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/144/title1.png" alt="" />
          <div class="content">
            <div class="des">
              <div>
                （一）注册地、经营地及税收解缴关系均在蒲江县的非公企业引进或培育的技能人才、专业技术人才和技能人才开发平台。
              </div>
            </div>
            <div class="des">
              <div>
                （二）申报人劳动关系和社保缴纳在蒲江县，与用人单位签订连续不少于5年的劳动合同，申报时在蒲已连续工作12个月及以上，未达到法定退休年龄且未提前退休；申报人所在企业遵纪守法，诚信经营。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/144/title2.png" alt="" />
          <div class="content">
            <div style="font-size: 0.34rem; font-weight: 600">
              <div class="circle" style="float: left"></div>
              （一）支持技能人才和专业技术人才发展
            </div>
            <div class="des">
              <div>
                1、对在蒲企业引进或培育的本县企业员工获得“中华技能大奖”称号的，给予每人30万元的一次性奖励；获得“全国技术能手”称号的，给予每人20万元的一次性奖励；获得“四川技能大师”和“四川省技术能手”称号的，给予每人10万元的一次性奖励。
              </div>
              <div>
                <span style="font-weight: 600">申报材料：</span> <br />
                （1）申报表原件； <br />
                （2）申报人身份证（护照）； <br />
                （3）相关证书、奖章或文件； <br />
                （4）劳动合同； <br />
                （5）企业统一社会信用代码证书； <br />
                （6）参保缴费凭证。 <br />
              </div>
              <div>
                2、对在蒲企业新引进或新培育的正高级、副高级专业技术职称人才，5年内每人每年，分别给予最高3.6万元、1.8万元的“人才津贴”。
              </div>
              <div>
                <span style="font-weight: 600">申报材料：</span> <br />
                （1）申报表原件； <br />
                （2）申报人身份证（护照）； <br />
                （3）相关职称资格证书； <br />
                （4）劳动合同； <br />
                （5）企业统一社会信用代码证书； <br />
                （6）参保缴费凭证。 <br />
              </div>
              <div>
                3、对在蒲企业新引进或新培育的高级工、技师、高级技师，5年内每人每年，分别给予0.6万元、1.2万元、1.8万元的“人才津贴”。
              </div>
              <div>
                <span style="font-weight: 600">申报材料：</span> <br />
                （1）申报表原件； <br />
                （2）申报人身份证（护照）； <br />
                （3）相关职称资格证书； <br />
                （4）劳动合同； <br />
                （5）企业统一社会信用代码证书； <br />
                （6）参保缴费凭证。 <br />
              </div>
            </div>
            <div
              style="font-size: 0.34rem; font-weight: 600; margin-top: 0.3rem"
            >
              <div class="circle" style="float: left"></div>
              （二）建设技能人才开发平台
            </div>
            <div class="des">
              <div>
                对在蒲培训机构、公共实训基地、企业技能培训中心，被新认定为国家、省、市级技能人才培训基地，分别给予100万元、50万元、10万元的一次性资助。技能领军人才新领（创）办国家、省、市级技能大师工作室，分别给予10万元、5万元、3万元的一次性资助。
              </div>
              <div>
                <span style="font-weight: 600">申报材料：</span> <br />
                （1）申报表原件； <br />
                （2）单位在银行开立的基本帐户、申报人身份证（护照）；<br />
                （3）相关证书或文件；<br />
                （4）统一社会信用代码证书；<br />
              </div>
            </div>
          </div>
        </div>
        <div class="part-four">
          <img src="../assets/imgs/144/title3.png" class="part-two-title-img" />
          <div class="main-content">
            <div class="part-four-items">
              <div class="title-bg">申报</div>
              <div class="part-four-content1">
                个人（平台）提出申请；相关佐证材料一式三份，验原件收复印件。
              </div>
            </div>
            <div class="part-four-items">
              <div class="title-bg title-bg2">
                <div class="extendFont">审核和公示</div>
              </div>
              <div class="part-four-content1">
                县人社局会同县财政局等相关部门审核后进行公示，公示期为5个工作日。
              </div>
            </div>
            <div class="part-four-items" style="border: none">
              <div class="title-bg title-bg3">资金发放</div>
              <div class="part-four-content1">
                经公示无异议的，按程序报批兑现。
              </div>
            </div>
          </div>
        </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/144/title4.png" alt="" />
          <div
            class="content"
            style="background-color: #fff; font-weight: bolder"
          >
            每年3月31日前。
          </div>
        </div>
        <div class="contact" style="margin-top: 0.3rem">
          <img class="top" src="./../assets/imgs/144/title5.png" alt="" />
          <div class="content">
            <div class="number">
              <span class="label">政策咨询电话：</span>
              <div>
                <a href="tel:028-88555682">028-88555682</a>
              </div>
            </div>
            <div class="unit">
              <span class="label">责任单位：</span>
              蒲江县人社局
            </div>
          </div>
        </div>
        <div class="codes">
          <img class="info" src="../assets/imgs/144/code.png" />
        </div>
      </div>
    </section>
    <!-- <call phone="028-84080490"></call> -->
  </div>
</template>

<script>
import call from "../components/call.vue";
export default {
  data() {
    return {};
  },

  components: {
    call,
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";
.circle {
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
  border: 0.06rem solid #ff6d60;
  margin-right: 0.08rem;
}
.part-four {
  width: 6.85rem;
  background: #e8eeff;
  border-radius: 10px;
  margin-left: 0.02rem;
  margin-top: 0.22rem;
  box-sizing: border-box;
  margin: 0 auto;
  margin-top: 0.22rem;
  border: 0.00001px solid transparent;
  position: relative;
  padding: 1.2rem 0.25rem 0 0.25rem;
  .part-two-title-img {
    width: 7.03rem;
    height: 1.37rem;
    top: 0;
    left: -0.2rem;
    position: absolute;
  }
  .main-content {
    margin-top: 0.34rem;
    width: 6.35rem;
    background: #ffffff;
    border-radius: 10px;
    box-sizing: border-box;
    padding-top: 0.9rem;
    padding-left: 0.35rem;
    padding-right: 0.31rem;

    .part-four-items {
      box-sizing: border-box;
      border-left: 0.02rem dashed #739bfe;
      margin-bottom: 0.6rem;
      padding-left: 0.33rem;
      padding-top: 0.2rem;
      position: relative;
      font-size: 0.26rem;
      // //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
      padding-bottom: 0.35rem;

      .title-bg {
        position: absolute;
        width: 3.31rem;
        height: 0.55rem;
        top: -0.6rem;
        left: -0.25rem;
        line-height: 0.55rem;
        font-size: 0.34rem;
        font-weight: bold;
        color: #3d5aa3;
        padding-left: 0.58rem;
        background: url(../assets/imgs/144/p1.png) 0 0/100% 100%;
        border: 1px solid #fff;
      }

      .title-bg2 {
        background: url(../assets/imgs/144/p2.png) 0 0/100% 100%;
      }

      .extendFont {
        min-width: 7rem;
        position: absolute;
        top: 50%;
        left: 0.58rem;
        transform: translateY(-50%);
      }

      .title-bg3 {
        background: url(../assets/imgs/144/p3.png) 0 0/100% 100%;
      }

      .title-bg4 {
        background: url(../assets/imgs/craft/part4-4.png);
        background-size: 100% 100%;
      }

      .title-bg5 {
        background: url(../assets/imgs/121/part5.png);
        background-size: 100% 100%;
      }

      .title-bg6 {
        background: url(../assets/imgs/121/part6.png);
        background-size: 100% 100%;
      }

      .inside-title {
        font-weight: 800;
      }

      .part-four-content2 {
        font-weight: bolder;
      }
    }
  }
}
.xlrclh {
  background-color: $base-back;
  padding-top: 0.3rem;
  overflow: hidden;
  .top-img {
    width: 7.4rem;
    height: 5.58rem;
  }

  .technological-process {
    transform: translateY(-1.9rem);

    .rhtj {
      position: relative;

      .top {
        width: 6.86rem;
        height: 2.12rem;
      }

      .content {
        width: 6.85rem;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        background: #ffffff;
        font-size: 0.26rem;
        color: #4e4e4e;
        text-align: left;
        position: relative;
        font-weight: 500;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          position: relative;
          text-align: left;
          margin-top: 0.2rem;
          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 4.86rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .gmlc {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.86rem;
        background: #e8eeff;
        margin: -0.55rem auto;
        padding: 0 0.33rem 0.35rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;

        .circle-box {
          font-size: 0.34rem;
          color: #333;
          font-weight: bold;
          padding-top: 0.5rem;
          text-align: left;
          position: relative;
          .circle {
            width: 0.28rem;
            height: 0.28rem;
            border: 0.06rem solid #ff6d60;
            border-radius: 50%;
            flex-shrink: 0;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 0.62rem;
            display: inline-block;
          }
          .circle-txt {
            text-indent: 1.1em;
          }
        }

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.3rem 0.23rem;
          font-size: 0.26rem;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;

          .line-item {
            font-size: 0.26rem;
            position: relative;
            z-index: 3;

            .line {
              position: absolute;
              width: 0.02rem;
              height: 130%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .line-title {
              font-size: 0.3rem;
              font-weight: bold;
              color: #3d5aa3;
            }

            .line-top {
              display: flex;
              width: 4.4rem;
              height: 0.55rem;
              background-image: url(../assets/imgs/25/label.png);
              background-size: 100% 100%;
              z-index: 99;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              padding-left: 0.1rem;

              .line-num {
                width: 0.44rem;
                height: 0.44rem;
                background: #fff;
                color: #3d5aa3;
                display: inline-flex;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                margin-right: 0.18rem;
                position: relative;
                z-index: 3;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.28rem;
                font-weight: bold;
              }
            }

            .line-content {
              //   border-left: 0.02rem dashed #739bfe;
              padding-bottom: 0.32rem;
              margin-left: 0.2rem;
              padding-left: 0.32rem;
              padding-top: 0.15rem;
              word-break: break-all;
              line-height: 0.44rem;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .info {
        width: 6.42rem;
        height: 1.94rem;
      }
    }
  }
}
</style>
